// Type Imports
import { CardType } from "../components/PricingTable/PricingTable";

// Image Imports
import Logo from "../components/Assets/logo2.png";
import QrCodeHand from "../components/Assets/qrhand.png";
import FREEPLAN from "../components/Assets/freeplan-img.png";
import PREMIUMPLAN from "../components/Assets/premiumplan-img.png";
import BUSINESSPLAN from "../components/Assets/businessplan-img.png";

//Component Imports
import Hero from "../components/Hero/Hero";
import PricingTable from "../components/PricingTable/PricingTable";
import Newsletter from "../components/Newsletter/Newsletter";
import Faq from "../components/Faq/Faq";
import Usecases from "../components/Usecases/Usecases";
import Features from "../components/Features/Features";
import Steps from "../components/Steps/Steps";
import FooterCta from "../components/FooterCta/FooterCta";

const Home = () => {
  let cards: CardType[] = [
    {
      cardHeading: "Free",
      cardMonthlyPricing: 0,
      cardAnnualPricing: 0,
      cardPoints: [
        "2 QR Codes",
        "5,000 Monthly Scans ",
        "Basic Customization",
        "Email support",
      ],
      cardCta: "Signup",
      cardId: "",
      cardRecommmended: false,
      cardImg: FREEPLAN,
    },
    {
      cardHeading: "Premium",
      cardMonthlyPricing: 10.99,
      cardAnnualPricing: 144.99,
      cardPoints: [
        "10 Dynamic QR Codes",
        "100,000 Monthly Scans",
        "Tracking with Analytics",
        "Premium QR Code Customization",
        "Priority Customer Support",
      ],
      cardCta: "Purchase",
      cardId: process.env.REACT_APP_STRIPE_PRODUCT_1,
      cardRecommmended: true,
      cardImg: PREMIUMPLAN,
    },
    {
      cardHeading: "Business",
      cardMonthlyPricing: 49.99,
      cardAnnualPricing: 669.99,
      cardPoints: [
        "Unlimited Monthly Scans",
        "Unlimited Dynamic QR Codes",
        "Detailed Tracking with Analytics",
        "Premium QR Code Customization",
        "Top Priority Customer Support",
      ],
      cardCta: "Purchase",
      cardId: process.env.REACT_APP_STRIPE_PRODUCT_2,
      cardRecommmended: false,
      cardImg: BUSINESSPLAN,
    },
  ];

  return (
    <div className="home">
      <Hero
        image={QrCodeHand}
        logo={Logo}
        heading="Get an Edge with QR Codes. Try it now for Free!"
        paragraph="Are you tired of plain, generic QR codes that just blend in? Say hello to QR Swift – your ultimate solution for creating personalized QR codes that make a statement and capture attention!"
        cta="Get Started For Free"
        cta2="Create Now"
      />
      <Steps />
      <Usecases />
      <Features />
      <PricingTable
        heading="Pricing"
        paragraph="QR Sharp offers unparalleled customization, security, and efficiency at prices that fit any budget. See how QR Sharp can transform your digital interactions below."
        annualSaving={20}
        heading2="Enterprise"
        paragraph2="Need something for tailor-made for your organization? Don't hesitate to get in contact. We can offer white labeling, higher usage limits and API integration."
        cta="Contact Us"
        cards={cards}
      />
      <Newsletter
        heading="Join our newsletter to stay up-to-date!"
        paragraph="Stay ahead in the world of QR codes! Join our newsletter to receive exclusive tips, updates, and inspiration on how QR Sharp can enhance your digital presence."
        cta="Join the QR Sharp Newsletter →"
      />
      <Faq />
      <FooterCta />
    </div>
  );
};

export default Home;
